import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { journalEntries } from '../../data/journalData';

const JournalTheatreSustainability = () => {
  const entry = journalEntries.find(e => e.id === 'from-survival-to-sustainability');
  const [selectedImage, setSelectedImage] = useState(null);

  // Keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!selectedImage) return;
      if (e.key === 'ArrowLeft') goToPrevious();
      else if (e.key === 'ArrowRight') goToNext();
      else if (e.key === 'Escape') closeLightbox();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [selectedImage]);

  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);

  const handleTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const handleTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    const distance = touchStart - touchEnd;
    if (distance > 50) goToNext();
    else if (distance < -50) goToPrevious();
  };

  const openLightbox = (image) => {
    setSelectedImage(image);
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    setSelectedImage(null);
    document.body.style.overflow = 'auto';
  };

  const goToPrevious = () => {
    // No gallery images for now
  };

  const goToNext = () => {
    // No gallery images for now
  };

  if (!entry) {
    return (
      <section className="not-found">
        <div className="container">
          <h2>Entry Not Found</h2>
          <Link to="/research-journal" className="btn">Back to Journal</Link>
        </div>
      </section>
    );
  }

  return (
    <>
      <section className="journal-entry-header">
        <div className="container">
          <div className="entry-meta-top">
            <span className="research-tag">{entry.researchArea}</span>
            &nbsp;|&nbsp;
            <span className="research-status">Research in Progress</span>
          </div>
          <h1>{entry.title}</h1>
          <p className="entry-abstract">{entry.abstract}</p>
          <div className="entry-meta-details">
            <p><strong>Lead Researcher:</strong> Valentine Zikki Kamau</p>
            <p><strong>Institution:</strong> ZIRAYA Institute, Mpenzi Mashini Limited</p>
            <p><strong>Research Period:</strong> 2026–Present</p>
            <p><strong>Research Areas:</strong> Theatre Sustainability, Cultural Memory, Creative Economies, Knowledge Transfer, Inclusion & Access</p>
          </div>
        </div>
      </section>

      <section className="journal-entry-content wide-container">
        <div className="container">
          <div className="entry-body">
            {entry?.body?.map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}
          </div>

          {/* Key Questions */}
          <div className="key-questions">
            <h2>Key Research Questions</h2>
            <ul>
              {entry?.keyQuestions?.map((question, index) => (
                <li key={index}>{question}</li>
              ))}
            </ul>
          </div>

          {/* Participate Section */}
          <div className="entry-section participate-box">
            <h2>Participate in the Study</h2>
            <p>
              ZIRAYA Institute invites theatre practitioners, educators, producers, cultural organisations, 
              students, and other stakeholders to contribute their experiences and insights to this evolving 
              body of research.
            </p>
            <div className="participate-links">
              <a 
                href="https://forms.gle/jj59usT8vRqYEDgK7" 
                target="_blank" 
                rel="noopener noreferrer"
                className="btn btn-large"
              >
                Take the Survey
              </a>
              <br />
              <br />
              <p className="contact-email">
                For interview participation, collaboration, or further information:<br />
                <a href="mailto:projects@zirayainstitute.org">projects@zirayainstitute.org</a>
              </p>
            </div>
          </div>

          <div className="back-to-journal">
            <Link to="/research-journal" className="text-link">← Back to Research Journal</Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default JournalTheatreSustainability;